<template>
  <div id="menu-item" style="width: fit-content" v-if="menuList && menuList.length">
    <template v-for="item in menuList" :key="`${targetId}$$${item.key}`">
      <div class="menu-son tag-chat-item" v-if="item.key === 'tag-chat-item'">
        <div class="menu-son-text f fc fbt">
          <span>{{ item.label }} </span>
          <RightOutlined />
        </div>
        <div class="tag-list">
          <div class="tag-list-wrap" v-if="calcReceiveLabelList.length">
            <div
              class="f fbt tag-item"
              v-for="tag in calcReceiveLabelList"
              :key="tag.id"
              @click="menuClick({ key: `${targetId}$$${item.key}$$${tag.id}` })"
            >
              <span>
                {{ tag.name }}
              </span>
              <CheckOutlined class="checked-icon" v-if="tag.selected" />
            </div>
          </div>
          <div class="add-item">
            <div class="tag-item" @click="handleAddTag">
              <PlusOutlined />
              <span>創建标签</span>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-son" v-else-if="item.key === 'context-edit'" @click="handleEditAction(targetId, item.key)">
        <div class="menu-son-text">
          <span>編輯</span>
        </div>
      </div>
      <div class="menu-son" v-else-if="item.key === 'context-remove'" @click="handleEditAction(targetId, item.key)">
        <div class="menu-son-text">
          <span>刪除</span>
        </div>
      </div>
      <div v-else class="menu-son" @click="menuClick({ key: `${targetId}$$${item.key}` })">
        <div class="menu-son-text">
          <span>{{ item.label }}</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { RightOutlined, PlusOutlined, CheckOutlined } from '@ant-design/icons-vue';
import { reactive, watch, computed } from 'vue';
import { storeToRefs } from 'pinia';
import type { MenuProps } from 'ant-design-vue';
import { contextMenuStore } from './store/contextMenuStore';
import { setContextMeneShow } from './hooks/useContextMenu';
import menuListMap from './MenuListMap';
import { chatStore } from '@/store/chatStore';
import actionMap from './ActionMap';
import { MSG_TYPE } from '@/lib/const';
import blackList from './BlackList';
import dayjs from 'dayjs';
import { useRoute } from 'vue-router';
import bus from '@/lib/bus';
import { isWechatBrowser } from '@/lib/utils';

const route = useRoute();
const chatStoreEx = chatStore();
const { currentChatRoomInfo, currentChatRoomMsgList, receiveLabelList, currentLabelGroupKey } =
  storeToRefs(chatStoreEx);

const contextMenuStoreEx = contextMenuStore();
const { targetIdArray, targetId } = storeToRefs(contextMenuStoreEx);
const calcChatPage = computed(() => ['/chat'].includes(route.fullPath));
const menuList = computed(() => {
  const idList = targetIdArray.value;
  const map = filterMapByRoomType(JSON.parse(JSON.stringify(menuListMap)), idList);
  const targetMainType = idList[0];
  const targetSubType = idList[1];
  // 禁用右键菜单消息统一设置 targetSubType 为 contextDisabled
  // 机器人接待列表不支持右键菜单 currentLabelGroupKey === 'robot'
  if (targetSubType === 'contextDisabled' || currentLabelGroupKey.value === 'robot') {
    return [];
  }
  // list为该大类型下固定的右键菜单选项
  const list = map[targetMainType] || [];

  let tmp = list;

  if (targetMainType === 'msg-item') {
    tmp = recallHandle(tmp, idList);
    if (['text', 'image', 'textInternal', 'imageInternal'].includes(targetSubType)) {
      // 文字类型支持复制、翻译
      tmp = [{ label: '複製', key: 'copy' }, ...list];
    }
    // 引用：默认支持文字、图片、  问先生支持视频、语音
    if (
      (!['text', 'image'].includes(targetSubType) &&
        !(['voice', 'video'].includes(targetSubType) && chatStoreEx.currentChatRoomInfo?.business_model?.type === 2)) ||
      (['qw', 'group'].includes(chatStoreEx.currentChatRoomInfo.roomType) && !['text'].includes(targetSubType))
    ) {
      // 非文字图片不支持引用
      tmp = tmp?.filter((i) => !['quote'].includes(i.key));
    }

    if (targetSubType === 'voice') {
      tmp = toTextHandle(tmp, idList);
    }

    if (
      ['emojiImage', 'applets', 'radarLink', 'card', 'robot', 'business_customize', 'leaveComment'].includes(
        targetSubType
      )
    ) {
      // 表情包、小程序不支持收藏
      tmp = list?.filter((i) => !['collect'].includes(i.key));
    }
    // H5文字支持翻译
    if (targetSubType === 'text' && chatStoreEx.currentChatRoomInfo.roomType === 'h5') {
      tmp = translationHandle(tmp, idList);
    }
  }
  if (targetMainType === 'chat-item') {
    tmp = filterChatTopMsg(tmp, idList);
    tmp = filterChatMarkMsg(tmp, idList);
    tmp = filterChatReceiveLabel(tmp, idList);
  }

  // 移动端不支持会话打标签
  if (isWechatBrowser) {
    tmp = tmp?.filter((i) => i.key !== 'tag-chat-item');
  }

  return tmp;
});
// 判断是否需要转文字
const toTextHandle = (list, idList) => {
  const msgId = idList[2];
  const target = currentChatRoomMsgList.value.find((i) => i.data.id == msgId);
  if (!target?.data?.text) {
    list.unshift({
      label: '轉文字',
      key: 'toText',
    });
  }
  return list;
};

// 判断是否能撤回
const recallHandle = (list, idList) => {
  if (idList.length > 2) {
    const msgId = idList[2];
    const target = currentChatRoomMsgList.value.find((i) => i.data.id == msgId);
    // 内部消息不支持撤回
    if (target && !target.data?.internal) {
      const created_at = target.data.created_at;
      const duration = [6].includes(currentChatRoomInfo.value?.source) ? 5 * 60 : 2 * 60;
      if (created_at + duration > dayjs().unix() && target.data?.msg_id && target.data?.is_me) {
        list.unshift({
          label: '撤回',
          key: 'recall',
        });
      }
    }
  }
  return list;
};
// 判断是否能翻译
const translationHandle = (list, idList) => {
  if (idList.length > 2) {
    const msgId = idList[2];
    const target = currentChatRoomMsgList.value.find((i) => i.data.id == msgId);
    if (target && !target.data?.translation) {
      list.push(
        {
          label: '英语转中文',
          key: 'translation',
        },
        {
          label: '粤语转中文',
          key: 'translationCantonese',
        }
      );
    }
  }
  return list;
};
const filterMapByRoomType = (map, idList) => {
  if (
    (chatStoreEx.currentChatRoomInfo.roomType === 'qw' && !chatStoreEx.currentChatRoomInfo.groupId) ||
    chatStoreEx.isInternalMsg
  ) {
    map['avatar-item'] = [];
  }

  if (['h5', 'qw', 'ip', 'group'].includes(chatStoreEx.currentChatRoomInfo.roomType)) {
    map['msg-item'] = [
      {
        label: '收藏',
        key: 'collect',
      },
      {
        label: '引用',
        key: 'quote',
      },
    ];
  }
  // 撤回消息不支持引用
  const msgId = idList?.length ? idList[2] : '';
  if (msgId && currentChatRoomMsgList.value.find((i) => i.data.id == msgId)?.data?.status === 3) {
    const index = map['msg-item']?.findIndex((v) => v.key === 'quote');
    index !== -1 && map['msg-item'].splice(index, 1);
  }

  return map;
};
// 判断能否置顶
const filterChatTopMsg = (list, idList) => {
  let index = list.findIndex((v) => v.key === 'top-chat-item');
  if (calcChatPage.value) {
    const target = chatStoreEx.currentChatList?.personal?.msgItems?.find((v) => String(v.id) === idList[1]) || {};
    if (target.group_id) {
      list.splice(index, 1);
    } else {
      list[index].label = target.is_top ? '取消置顶' : '置顶';
    }
  } else {
    list.splice(index, 1);
  }
  return list;
};
// 标记
const filterChatMarkMsg = (list, idList) => {
  let index = list.findIndex((v) => v.key === 'mark-chat-item');
  if (calcChatPage.value) {
    let type = route.fullPath === '/chat' ? 'personal' : 'team';
    const target =
      (chatStoreEx.currentChatList &&
        chatStoreEx.currentChatList[type]?.msgItems?.find((v) => String(v.id) === idList[1])) ||
      {};
    list[index].label = target.is_mark ? '取消標記' : '標記';
  } else {
    list.splice(index, 1);
  }
  return list;
};
// 标签
const calcReceiveLabelList = computed(() => {
  return receiveLabelList.value
    ?.filter((v) => (calcChatPage.value ? v?.type === 0 : v?.type === 1))
    ?.map((v) => {
      v.selected = chatSelectedLabelIds.value.includes(v.id);
      return v;
    });
});
const chatSelectedLabelIds = ref([]);
const filterChatReceiveLabel = (list, idList) => {
  let type = calcChatPage.value ? 'personal' : 'team';
  const target =
    (chatStoreEx.currentChatList &&
      chatStoreEx.currentChatList[type]?.msgItems?.find((v) => String(v.id) === idList[1])) ||
    {};
  chatSelectedLabelIds.value = target.labels?.map((v) => v.id) || [];
  return list;
};
watch(
  targetIdArray,
  (newValue, oldValue) => {
    if (newValue.length > 0) {
      handleTargetIdArray(newValue);
    }
  },
  { deep: true }
);
const handleTargetIdArray = (list: Array<string>) => {
  if (Object.keys(menuListMap).includes(list[0]) && !inBlackList(list)) {
    console.log('触发右键', list);
    setContextMeneShow(true);
  } else {
    setContextMeneShow(false);
  }
};
const inBlackList = (list) => {
  const tmp = blackList.includes(list[0]);
  if (tmp) {
    console.log('触发右键但被屏蔽', list);
  }
  return tmp;
};

const menuClick: MenuProps['onClick'] = (menuInfo) => {
  const key: string = menuInfo.key as string;
  const target = key.split('$$')[0];
  const action = key.split('$$')[1];
  const tagItemId = key.split('$$')[2];
  handleClick(action, target, tagItemId);
};

const handleClick = (action: string, target: string, tagItemId?: string) => {
  const targetArray = target.split('_');
  let targetItem, targetItemType, targetItemId;
  if (targetArray.length === 2) {
    targetItem = targetArray[0];
  } else if (targetArray.length === 3) {
    targetItem = targetArray[0];
    targetItemType = '';
    targetItemId = targetArray[1];
  } else if (targetArray.length === 4) {
    targetItem = targetArray[0];
    targetItemType = targetArray[1];
    targetItemId = targetArray[2];
  }
  actionMap[action] &&
    typeof actionMap[action][targetItem] === 'function' &&
    actionMap[action][targetItem]({
      targetItem,
      targetItemType,
      targetItemId: String(targetItemId),
      tagItemId: String(tagItemId),
    });
};
// 右键编辑、删除
const handleEditAction = (target, action) => {
  let targetArray = target.split('_');
  if (targetArray.length === 4 && targetArray[0] == 'context-edit-remove') {
    let targetId = targetArray[1];
    let eventName = targetArray[2];
    bus.emit(eventName, {
      action,
      targetId,
    });
  }
};
const handleAddTag = () => {
  setContextMeneShow(false);
  bus.emit('openChatAddSessionTag');
};
</script>
<style lang="less">
#menu-item {
  width: 100px !important;
  background-color: #fff;
  border: 1px solid #dededf;
  border-radius: 10px;
  .menu-son {
    height: 34px;
    line-height: 18px;
    margin: 0 !important;
    padding: 2px 2px 2px 5px !important;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    &-text {
      padding: 5px 3px;
      border-radius: 5px;
      &:hover {
        background-color: #edeeee;
      }
    }
  }
  .menu-son:last-child {
    border-bottom: none;
  }
  .tag-chat-item {
    position: relative;
    padding: 3px 2px 3px 5px !important;
    .tag-list {
      display: none;
      position: absolute;
      left: 98px;
      bottom: 0;
      transform: translateY(50%);
      min-width: 150px;
      padding: 3px 0;
      background-color: #fff;
      border-radius: 8px;
      border: 1px solid #dededf;
      .tag-list-wrap {
        overflow: auto;
        max-height: 220px;
        border-bottom: 1px solid #dededf;
      }
      .tag-item {
        margin: 1px 0;
        padding: 5px;
        border-radius: 5px;
        &:hover {
          background-color: #edeeee;
        }
        .checked-icon {
          color: #0072f9;
          font-size: 12px;
        }
      }
      .add-item {
        background-color: #fff;
      }
    }
    &:hover .tag-list {
      display: block;
    }
  }
}
</style>
